<template>
  <!-- 应收暂支未清预警：客户应收未清（账龄 = 当前时间 - 开票时间）/ 暂支未清（账龄 = 当前时间 - 暂支时间） -->
  <riskWarn domain="ar" pageTitle="应收暂支未清预警" themeColor="#2E7BFF"
    :subTabs="['客户应收未清', '暂支未清']" :showAmount="true" />
</template>

<script>
import riskWarn from './riskWarn'
export default {
  name: 'arUncleared',
  components: { riskWarn }
}
</script>
